<template>

  <div class="PayBill">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>

                          মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>বিদ্যুতৰ বিল পৰিশোধ </b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">আপোনাৰ বিদ্যুতৰ বিল পৰিশোধ কৰক</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
           <br>
          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->


         <b-row>
               <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                     <span style="font-weight:600" >উপভোক্তা নম্বৰ <span class="text-danger">*</span></span>
               </b-col>
               <b-col col cols="8" sm="8" md="8" lg="4">
                   <b-form-input type="number" maxlength="12" id="consNo" value=""  placeholder="আপোনাৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক" trim required />
               </b-col>
               <b-col col cols="4" sm="3" md="3" lg="1">
                     <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                       <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                     </b-button>

               </b-col>
          </b-row>
    </br>
    <div id="BillDetails" class="billDetails">
          <b-row>
            <b-col cols=12>
                <span class="heading">বিলৰ সাৰাংশ</span>
            </b-col>
          </b-row>
          <hr/>
          <b-row class="paddingRow">
            <b-col cols="12" sm="6" md="6" lg="6">
              <span class="label">উপভোক্তা নাম: </span>
              <span class="" id="consName"></span>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="6">
              <span class="label">উপ-সংমণ্ডল: </span>
              <span class="" id="subDiv"></span>
            </b-col>
            <!-- <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol displayProp">
              <span class="label">  ম'বাইল নম্বৰ<span class="text-danger">*</span>:  </span>
              <b-form-input type="number" id="mobileNo" class="inputWidth" placeholder="ম'বাইল নম্বৰ" trim />
            </b-col>
            <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol displayProp">
              <span class="label"> ই-মেইল:  </span>
              <b-form-input type="email" id="emailId" class="inputWidth" placeholder="ই-মেইল" trim />
            </b-col> -->
          </b-row>
          <b-row class="">
            <b-col col cols="12" sm="12" md="12" lg="12">
              <b-table responsive bordered   :items="consumerBill" :fields="consumerBillFields">
                  <template v-slot:cell(bill_type)="data">
                    <span   v-html="data.value"></span>
                 </template>
                 <template v-slot:cell(bill_no)="data">
                   <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(bill_date)="data">
                  <span   v-html="data.value"></span>
               </template>
                 <template v-slot:cell(due_date)="data">
                   <span   v-html="data.value"></span>
                </template>
                 <template v-slot:cell(bill_amt)="data">
                   <span   v-html="data.value"></span>
                </template>
              </b-table>
              </b-col>
          </b-row>

          <b-row class="paddingRow">
            <b-col cols="12" sm="4" md="4" lg="4" class="paddingCol displayProp">
              <span class="label" style="padding-right: 10px;">  ম'বাইল নম্বৰ <span class="text-danger">*</span></span>
              <b-form-input type="number" id="mobileNo" class="inputWidth" placeholder=" ম'বাইল নম্বৰ" trim />
            </b-col>
            <b-col cols="12" sm="4" md="4" lg="4" class="paddingCol displayProp">
              <span class="label" style="padding-right: 10px;"> ই-মেইল </span>
              <b-form-input type="email" id="emailId" class="inputWidth" placeholder="ই-মেইল" trim />
            </b-col>
            <b-col cols="12" sm="3" md="3" offset-md="1" lg="3" offset-lg="1">
              <b-button block squared variant="primary" class="marginTop" @click="payNow()">
               <b-icon icon="credit-card" animation=""  >  </b-icon> পৰিশোধ কৰক
             </b-button>
            </b-col>
          </b-row>
          </div>
      </div>
  </b-container>

  <b-container id="billdeskRequestDiv" fluid style="padding-top: 100px;text-align:left;display:none">

    <br><br>
  <b-row id="spinner" style="display:block">
    <b-col cols=12 align="center">
      <h3 class="">Processing Payment Request...</h3>
      <br><br>
        <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
      <br><br><br>
     <h5 style="color:red">Please do not press back or refresh button</h5>
  </b-col>
  </b-row>
  <b-row id="errorDiv" style="display:none">
    <b-col cols=12 align="center">
    <h2 style="color:red" id="errorMsg"></h2>
      <br><br>
    <b-button onclick="window.location.reload();">Go Back</b-button>
    </b-col>
  </b-row>
</b-container>
<br><br>
</b-overlay>
<form :action = "reqUrl" method="post" id="pgrequest" hidden>
    <input type="" name="msg" :value = "messageToSend" hidden >
    <input type="submit" id="submit" value="submit" hidden>
</form>
    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="holdingModal" centered  scrollable title="ATTENTION !" :static="true" hide-footer>
      <div  style="background-color: #fffec49e;padding:1rem">
      <span class="" id="msg" style="color:#e64a19;font-size:1.05rem;font-weight:500">
        জিএমচি এলেকাৰ অধীনত গ্ৰাহকসকলক ৩১/১০/২০২২ তাৰিখৰ পূৰ্বে তেওঁলোকৰ জিএমচি হোল্ডিং নং/মূল্যায়ন আইডি আপডেট কৰিবলৈ আবেদন জনোৱা হৈছে।
        <br>ইতিমধ্যে আপডেইট কৰিলে আওকাণ কৰক। </span>
      <br><br>
      <a href="HoldingNoUpdate" class="blink_me">হোল্ডিং নম্বৰ আপডেট কৰিবলৈ ইয়াত ক্লিক কৰক</a>
      <br><br>
         <b-button  style="" variant="outline-primary" @click="closeModalH()">
          SKIP আৰু PAY কৰিবলৈ আগবাঢ়ক
         </b-button>
       </div>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var consNo="";
var sdCode="";
var thColor = '#0288d1';
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
      message : [
        "",
        "এই উপভোক্তা নম্বৰ বৈধ নহয়",
        "এই উপভোক্তা নম্বৰৰ কোনো বকেয়া বিল নাই ",
        "এই উপভোক্তা নম্বৰ অৱৰোধ কৰা হৈছে",
        "পৰিশোধৰ বাবে কোনো বিল পোৱা নগ'ল",
        "",
        "চাৰ্ভাৰ ব্যস্ত! অনুগ্ৰহ কৰি কিছু সময়ৰ পিছত পুনৰ চেষ্টা কৰক",
        "লেনদেন ইতিমধ্যে চলি আছে",
        "বিলডেস্কৰ সৈতে পৰিশোধ অনুৰোধ আৰম্ভ কৰাত ত্ৰুটি"
      ],
      messageToSend:"",
      reqUrl:"",
      consumerBillFields: [
        { key: 'bill_type', label: 'বিলৰ ধৰণ',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'bill_no', label: 'বিল নম্বৰ',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'bill_date', label: 'বিলৰ তাৰিখ',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'due_date', label: 'দেয় তাৰিখ',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'bill_amt', label: 'বিলৰ পৰিমাণ',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px',textAlign:''} }
      ],
      consumerBill : []

    }
  },
  methods: {
    showDetails() {

    const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","023","025"]
    consNo = document.getElementById("consNo").value;
    var sdCode=consNo.substring(0,3);
    console.log("sdCode:::"+sdCode);
    var isGmcCons = sdList.includes(sdCode);
    console.log("isGmcCons:::"+isGmcCons)

    if (consNo.toString().length!=12)
        {
          this.$bvToast.toast('১২ টা অংকৰ উপভোক্তা নম্বৰ প্ৰবিষ্ট কৰক !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }
        var parent = this;
        parent.consumerBill=[];
          this.show= true;

           axios.post(this.$urlArms+'/RestAPI/OnlinePayment/consBillDetailsBilldesk?consumerNo='+consNo)
          //axios.post('https://uat.apdclrms.com/onlinepayment/RestAPI/OnlinePayment/consBillDetailsBilldesk?consumerNo='+consNo)
          .then((response) => {
          //  console.log(response.data);
            var data=response.data.data;
            var msg=response.data.message;

            if(msg=="00") {


                if(isGmcCons)
                {
                   axios.post(parent.$urlCommon+'/api/web/getHoldingDetails?consNo='+consNo)
                    .then((response) => {
                    parent.show= false;
                    console.log(response.data);
                    if(response.data.data == "Consumer Not Found")
                    {
                      document.getElementById("BillDetails").classList.remove("showBillDetails");
                      parent.$bvModal.show("holdingModal");
                    //  return;
                    }
                  //  else
                    {
                      var res=data.due_date.split("-");
                      var dueDate= res[2]+"-"+res[1]+"-"+res[0];

                      var bdate=data.bill_date.split("-");
                      var billDate=bdate[2]+"-"+bdate[1]+"-"+bdate[0];

                      var rddate= '';
                      var rcdcDate= '';

                      if(data.rcdc_charge>0){
                        rddate=data.rcdc_bill_date.split("-");
                        rcdcDate=rddate[2]+"-"+rddate[1]+"-"+rddate[0];
                      }
                      else{
                        rcdcDate="-";
                      }

                      sdCode = data.sd_code;
                      document.getElementById("consName").innerHTML=data.cons_name;
                      document.getElementById("subDiv").innerHTML=data.sd_name;
                      var tot = data.rcdc_charge+data.due_amount;
                      parent.show= false;
                      document.getElementById("BillDetails").classList.add("showBillDetails");
                      var enrgyObj={bill_type: '<div class="mobileFont">Energy Bill Details</div>',bill_no:'<div class="mobileFont">'+data.bill_no+'</div>',bill_date: '<div class="mobileFont">'+billDate+'</div>', due_date:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem;'>"+dueDate+"</div>", bill_amt: "<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.due_amount+"</div>"};
                      var rcObj={bill_type: '<div class="mobileFont">RC/DC Bill Details</div>',bill_no:'<div class="mobileFont">'+data.rcdc_bill_no+'</div>', bill_date: '<div class="mobileFont">'+rcdcDate+'</div>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.rcdc_charge+"</div>"}
                      var totObj={due_date: '<span class="mobileFont" style="font-weight: 600;">Total Payable Amount:</span>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+tot+"</div>"}

                      if(data.rcdc_charge>0){
                        parent.consumerBill.push(enrgyObj);
                        parent.consumerBill.push(rcObj);
                        parent.consumerBill.push(totObj);
                      }
                      else{
                        parent.consumerBill.push(enrgyObj);
                      }

                   document.getElementById("BillDetails").classList.add("showBillDetails");
                    }
                  })

                }
                else{
                  parent.show= false;

                              var res=data.due_date.split("-");
                              var dueDate= res[2]+"-"+res[1]+"-"+res[0];

                              var bdate=data.bill_date.split("-");
                              var billDate=bdate[2]+"-"+bdate[1]+"-"+bdate[0];

                              var rddate= '';
                              var rcdcDate= '';

                              if(data.rcdc_charge>0){
                                rddate=data.rcdc_bill_date.split("-");
                                rcdcDate=rddate[2]+"-"+rddate[1]+"-"+rddate[0];
                              }
                              else{
                                rcdcDate="-";
                              }

                              sdCode = data.sd_code;
                              document.getElementById("consName").innerHTML=data.cons_name;
                              document.getElementById("subDiv").innerHTML=data.sd_name;
                              var tot = data.rcdc_charge+data.due_amount;
                              parent.show= false;
                              document.getElementById("BillDetails").classList.add("showBillDetails");
                              var enrgyObj={bill_type: '<div class="mobileFont">শক্তি বিলৰ সবিশেষ</div>',bill_no:'<div class="mobileFont">'+data.bill_no+'</div>',bill_date: '<div class="mobileFont">'+billDate+'</div>', due_date:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem;'>"+dueDate+"</div>", bill_amt: "<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.due_amount+"</div>"};
                              var rcObj={bill_type: '<div class="mobileFont">আৰ চি/ডি চি বিলৰ সবিশেষ</div>',bill_no:'<div class="mobileFont">'+data.rcdc_bill_no+'</div>', bill_date: '<div class="mobileFont">'+rcdcDate+'</div>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.rcdc_charge+"</div>"}
                              var totObj={due_date: '<span class="mobileFont" style="font-weight: 600;">মুঠ পৰিমাণ:</span>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+tot+"</div>"}

                              if(data.rcdc_charge>0){
                                parent.consumerBill.push(enrgyObj);
                                parent.consumerBill.push(rcObj);
                                parent.consumerBill.push(totObj);
                              }
                              else{
                                parent.consumerBill.push(enrgyObj);
                              }

                     document.getElementById("BillDetails").classList.add("showBillDetails");
                     }
            }
            else
            {
              this.show= false;
              this.$bvModal.show("model");
              document.getElementById("msg").innerHTML=this.message[parseInt(msg)];
              document.getElementById("BillDetails").classList.remove("showBillDetails");
            }


          })
          .catch((e) => {
          console.log("Caught", e);
          this.show= false;
          this.$bvModal.show("model");
          document.getElementById("msg").innerHTML="Sorry, Consumer / Bill not Found";
          document.getElementById("BillDetails").classList.remove("showBillDetails");
        })


      },

    payNow()
    {
      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;

      if (mobileNo.length!=10)
          {
            this.$bvToast.toast("১0 টা অংকৰ ম'বাইল নম্বৰ প্ৰবিষ্ট কৰক !", {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobileNo").focus();
            return
          }

    document.getElementById("consBillDiv").style.display="none";
    document.getElementById("billdeskRequestDiv").style.display="block";
    var parent= this;
    axios.post( this.$urlCommon+'/api/onlinepostpaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode)
    .then((response) => {
      console.log(response.data);
      var data=response.data;
      var msg=response.data.message;

      if(msg=="00") {
        parent.reqUrl = data.action;
        parent.messageToSend= data.msg;
      setTimeout(function(){ document.getElementById("submit").click(); }, 2000);
      }
      else
      {
        document.getElementById('spinner').style.display = 'none';
        document.getElementById('errorDiv').style.display = 'block';
        document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
        this.$bvModal.show("model");
        document.getElementById("msg").innerHTML=this.message[parseInt(msg)];
        //document.getElementById("BillDetails").classList.remove("showBillDetails");
      }

    })
    .catch((e) => {
      parent.show= false;
      parent.$bvModal.show('model');
      document.getElementById("msg").innerHTML="Sorry, Please Try Again Later";
      console.log("Caught :::::::::::::::", e.message);

  })

    },
    closeModal(){
      this.$bvModal.hide('model')
    },
    closeModalH(){
      this.$bvModal.hide('holdingModal')
    }



  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

.blink_me {
  animation: blinker 1s linear infinite;
  font-weight:600;
}

@keyframes blinker {
  50% {
    /* color:red; */
     opacity: 0;
  }
}
/deep/ .table > tbody > tr > td {
  padding: 0.20rem !important;
}
/deep/ .table > tbody > tr > th {
  padding: 0.20rem !important;
}
max-width: 300px;
.paddingTh{
  padding: 0.20rem !important;
}
.paddingTd{
  padding: 0.20rem !important;
}
.displayProp{
  display: -webkit-box;
}
.inputWidth{
  width:75%;
  margin-top: -6px;
}
.paddingRow{
  padding:0.7rem;
}
.paddingLeft{
  padding-left: 0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.billDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showBillDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}
.marginTop{
  margin-top: -8px;
}
@media (max-width: 768px) {
/deep/ .mobileFont{
    font-size: 12px !important;
  }
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
    .displayProp{
      display: block;
    }
    .inputWidth{
      width:100%;
      margin-top: 0px;
    }
    .marginTop{
      margin-top: 22px;
    }
    /* .paddingCol{
      padding: 0.7rem;
    } */
  }
@media only screen and (max-width: 414px) {
/deep/ .mobileFont{
    font-size: 12px !important;
  }
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
  .displayProp{
    display: block;
  }
  .inputWidth{
    width:100%;
    margin-top: 0px;
  }
  .marginTop{
    margin-top: 0px;
  }
}

@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial,Assamese_Font;
}
</style>
